// components/common/SearchInput/SearchInput.tsx
import React, { useState, useEffect } from "react";
import { TextInput, ActionIcon, TextInputProps } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useDebounce } from "utils/hooks/common/useDebounce";

interface SearchInputProps extends Omit<TextInputProps, "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
  debounceTime?: number;
}

export const SearchInput = ({
  value,
  onChange,
  debounceTime = 500,
  placeholder = "Tìm kiếm...",
  ...props
}: SearchInputProps) => {
  const [localValue, setLocalValue] = useState(value);
  const debouncedValue = useDebounce(localValue, debounceTime);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  const handleClear = () => {
    setLocalValue("");
    onChange("");
  };

  return (
    <TextInput
      placeholder={placeholder}
      value={localValue}
      onChange={(e) => setLocalValue(e.currentTarget.value)}
      leftSection={<IconSearch size={16} stroke={1.5} />}
      rightSection={
        localValue ? (
          <ActionIcon
            size="sm"
            variant="transparent"
            c="gray.5"
            onClick={handleClear}
          >
            <IconX size={14} stroke={1.5} />
          </ActionIcon>
        ) : null
      }
      radius="md"
      w={{ base: "100%", sm: 250 }} // Responsive width
      {...props}
    />
  );
};
